export type TransactionQueueItemStatus =
  | 'idle'
  | 'pendingSignature'
  | 'pendingConfirmation'
  | 'success'
  | 'skipped'
  | 'failed';

export interface TransactionQueueItem {
  id: string;
  label: string;
  status: TransactionQueueItemStatus;
}

export interface TransactionQueueProps {
  items: TransactionQueueItem[];
}

const statusLabels: Record<TransactionQueueItemStatus, string> = {
  idle: 'Waiting',
  pendingSignature: 'Waiting for signature',
  pendingConfirmation: 'Confirming',
  success: 'Confirmed',
  skipped: 'Skipped',
  failed: 'Failed',
};

const statusClasses: Record<TransactionQueueItemStatus, string> = {
  idle: 'text-light-grey',
  pendingSignature: 'text-blue',
  pendingConfirmation: 'text-blue',
  success: 'text-green',
  skipped: 'text-light-grey',
  failed: 'text-red',
};

export const TransactionQueue: React.FC<TransactionQueueProps> = ({ items }) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <div
      className="rounded-md border border-lightGrey/30 p-3 text-sm"
      data-testid="transaction-queue"
    >
      <p className="mb-2 font-semibold">Transaction queue</p>

      <ol className="space-y-2">
        {items.map((item, index) => (
          <li key={item.id} className="flex items-center justify-between gap-3">
            <span>
              <span aria-hidden="true">{index + 1}. </span>
              <span>{item.label}</span>
            </span>
            <span className={statusClasses[item.status]}>{statusLabels[item.status]}</span>
          </li>
        ))}
      </ol>
    </div>
  );
};
